import { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { isAuthenticatedAtom } from 'shared/auth/state/authAtoms'
import { subscribeSessionExpired } from 'shared/auth/sessionExpiry'
import { useAuth } from './useAuth'

/**
 * 認証済みの間、API セッション切れを監視し、切れたらセッションを破棄する。
 *
 * API セッションには refresh の仕組みが無いため、失効後はログインし直す以外に回復できない。
 * 状態を未認証へ戻せば、ログイン画面への遷移は useAuthRedirect が行う。
 * (Cognito 時代の useTokenRefresh の置き換え。)
 */
export const useSessionExpiry = (): void => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const { endSession } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) return
    return subscribeSessionExpired(() => { void endSession() })
  }, [isAuthenticated, endSession])
}
